import { api } from "roboflex-thalamus-request-handler";
import { sso } from "roboflex-thalamus-sso-lib";

let cachePermissao = { userId: null, data: null };

export const getPermissao = async () => {
  try {
    const usuarioLogado = sso.getUsuarioLogado();
    const userId = usuarioLogado?.id;
    if (!userId) return [];

    if (cachePermissao.userId === userId && cachePermissao.data !== null) {
      return cachePermissao.data;
    }

    const response = await api.get(`usuario/${userId}/funcionalidades`);
    const data = response.data.funcionalidade_id ?? [];
    cachePermissao = { userId, data };
    return data;
  } catch (error) {
    console.error("Erro ao obter permissões", error);
    return [];
  }
};

/** Limpa o cache (ex.: após logout) para forçar nova requisição na próxima sessão. */
export const limparCachePermissao = () => {
  cachePermissao = { userId: null, data: null };
};
